import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { cn } from '../../lib/utils';
import Icon from '../AppIcon';


export default function MobileAdminHeader({ title, navigationItems, onLogout }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      {/* Mobile Header - Sticky */}
      <header className="md:hidden sticky top-0 z-50 bg-white shadow-md">
        <div className="flex items-center justify-between px-4 py-3">
          {/* Left: Logo */}
          <div className="text-xl font-bold text-green-600">ADT</div>
          
          {/* Center: Page Title */}
          <div className="text-sm font-semibold text-gray-800 truncate max-w-[150px]">
            {title}
          </div>
          
          {/* Right: Hamburger Button */}
          <button
            onClick={toggleDrawer}
            className="p-2 rounded-md hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            <Menu size={24} className="text-gray-800" />
          </button>
        </div>
      </header>

      {/* Mobile Drawer Overlay */}
      {isDrawerOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={toggleDrawer}
        />
      )}

      {/* Mobile Drawer */}
      <aside
        className={cn(
          'fixed top-0 right-0 bottom-0 w-64 bg-white shadow-xl z-50 transform transition-transform duration-300 md:hidden',
          isDrawerOpen ? 'translate-x-0' : 'translate-x-full'
        )}
      >
        {/* Drawer Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="text-lg font-bold text-green-600">Menu Admin</div>
          <button
            onClick={toggleDrawer}
            className="p-2 rounded-md hover:bg-gray-100 transition-colors"
            aria-label="Close menu"
          >
            <X size={24} className="text-gray-800" />
          </button>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col p-4 space-y-2">
          {navigationItems?.map((item) => {
            const Icon = item?.icon;
            return (
              <button
                key={item?.path}
                onClick={() => {
                  item?.onClick?.();
                  toggleDrawer();
                }}
                className={cn(
                  'flex items-center space-x-3 px-4 py-3 rounded-md text-sm font-medium transition-colors',
                  item?.isActive 
                    ? 'bg-green-50 text-green-600' :'text-gray-800 hover:bg-gray-100'
                )}
              >
                {Icon && <Icon size={20} />}
                <span>{item?.name}</span>
              </button>
            );
          })}
        </nav>

        {/* Logout Button at Bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <button
            onClick={() => {
              onLogout?.();
              toggleDrawer();
            }}
            className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-red-50 text-red-600 rounded-md hover:bg-red-100 transition-colors font-medium"
          >
            <span>Déconnexion</span>
          </button>
        </div>
      </aside>
    </>
  );
}